import React from 'react';
import { Card, Radio, Space } from 'antd';

export function QuestionCard({ question, questionIndex, selectedOptionIndex, onSelectOption }) {
  return (
    <Card
      style={{
        borderRadius: 10,
        marginBottom: 20,
        border: '1px solid #e2e8f0',
      }}
      styles={{ body: { padding: '24px 20px' } }}
    >
      {/* Question Prompt */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 18 }}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 28,
            height: 28,
            borderRadius: '50%',
            background: '#0284c7',
            color: '#fff',
            fontWeight: 700,
            fontSize: 13,
            flexShrink: 0,
          }}
        >
          {questionIndex + 1}
        </span>
        <div style={{ fontSize: 16, fontWeight: 600, color: '#0f172a', lineHeight: 1.5 }}>
          {question.prompt}
        </div>
      </div>

      {/* Options List */}
      <Radio.Group
        value={selectedOptionIndex}
        onChange={(e) => onSelectOption(question.id, e.target.value)}
        style={{ width: '100%' }}
      >
        <Space direction="vertical" style={{ width: '100%' }} size={10}>
          {question.options?.map((opt, idx) => {
            const isChecked = selectedOptionIndex === idx;
            return (
              <div
                key={idx}
                onClick={() => onSelectOption(question.id, idx)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 16px',
                  borderRadius: 8,
                  background: isChecked ? '#f0f9ff' : '#f8fafc',
                  border: isChecked ? '1px solid #0284c7' : '1px solid #e2e8f0',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                }}
              >
                <Radio value={idx} style={{ width: '100%' }}>
                  <span style={{ fontSize: 14, color: '#334155', fontWeight: isChecked ? 600 : 400 }}>
                    {opt.text}
                  </span>
                </Radio>
              </div>
            );
          })}
        </Space>
      </Radio.Group>
    </Card>
  );
}
